<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="loading_overlay rounded" *ngIf="showSpinner">
    <app-loader></app-loader>
  </div>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ 'orgnotificationsetting.notificationsettings' | trans }}</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col">
          <h6 (click)="toggleOrg()" [ngClass]="{'weight-500': !showcustomeruseroptions}"
            class="font-weight-light cursor-pointer">{{
            'orgnotificationsetting.organisationnotifications' | trans
            }}
          </h6>
        </div>
        <div class="col">
          <h6 (click)="toggleCustomeruser()" [ngClass]="{'weight-500': showcustomeruseroptions}"
            class="font-weight-light float-right cursor-pointer">{{
            'customeruser.organisationnotifications' | trans }}</h6>
        </div>
      </div>


      <!---org notification settings---->
      <div [@inbgOutAnimation] *ngIf="!showcustomeruseroptions">
        <div class="alert alert-danger mr-0 ml-0" role="alert">
          {{ 'orgnotificationsetting.changenotificationpreferenceses' | trans }}
          <p class="p" *ngIf="notificationList && notificationList.length == 0">{{noNotificationsMsg}}</p>
        </div>
        <div class="mt-2 mb-2">
          <button (click)="checkAll()" class="btn">
            <p class="btn-text">{{ 'orgnotificationsetting.selectall' | trans }}</p>
          </button>
          <button (click)="checkNone()" class="btn ml-2">
            <p class="btn-text">{{ 'orgnotificationsetting.unselectall' | trans }}</p>
          </button>
        </div>
        <p style="margin-bottom: 0px;">{{ 'orgnotificationsetting.thisisarethesettingsforthecurrentorganization' | trans
          }}</p>
        <div class="form-check">
          <input [checked]="overduecheck" (change)="setNotificationPreference($event,'projectturnsoverdue')"
            type="checkbox" class="form-check-input" [checked]="notificationpreferenceset.projectturnsoverdue">
          <label class="f-13 mb-0 font-weight-light" for="projectturnsoverdue_magicBtn">{{
            'orgnotificationsetting.projectturnsoverdue' | trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="memberfarbehindcheck" (change)="setNotificationPreference($event,'memberfarbehind')"
            id="memberfarbehind_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.memberfarbehind">
          <label class="f-13 mb-0 font-weight-light" for="memberfarbehind_magicBtn">{{
            'orgnotificationsetting.memberisfarbehindschedule' | trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="newprojectcheck" (change)="setNotificationPreference($event,'newproject')"
            id="newproject_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.newproject">
          <label class="f-13 mb-0 font-weight-light" for="newproject_magicBtn">{{
            'orgnotificationsetting.newprojectcreated' | trans }}</label>
        </div>
        <div *ngIf="showDeal" class="form-check">
          <input [checked]="newdealcheck" (change)="setNotificationPreference($event,'newdeal')" id="newdeal_magicBtn"
            type="checkbox" class="form-check-input" [checked]="notificationpreferenceset.newdeal">
          <label class="f-13 mb-0 font-weight-light" for="newdeal_magicBtn">{{ 'orgnotificationsetting.newdealcreated' |
            trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="projectdisabedcheck" (change)="setNotificationPreference($event,'projectdisabed')"
            id="projectdisabed_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.projectdisabed">
          <label class="f-13 mb-0 font-weight-light" for="projectdisabed_magicBtn">{{
            'orgnotificationsetting.projectdisabled' | trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="projectreenabledcheck" (change)="setNotificationPreference($event,'projectreenabled')"
            id="projectreenabled_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.projectreenabled">
          <label class="f-13 mb-0 font-weight-light" for="projectreenabled_magicBtn">{{
            'orgnotificationsetting.projectre-enabled' | trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="projectdeletedcheck" (change)="setNotificationPreference($event,'projectdeleted')"
            id="projectdeleted_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.projectdeleted">
          <label class="f-13 mb-0 font-weight-light" for="projectdeleted_magicBtn">{{
            'orgnotificationsetting.projectdeleted' | trans }}</label>
        </div>
      </div>
      <!---org notification settings end---->

      <!---customer user settings----
      <ng-container [@inbgOutAnimation] *ngIf="showcustomeruseroptions">
        <div class="alert alert-danger mr-0 ml-0" role="alert">
          {{ 'customerusernot.changenotificationpreferenceses' | trans }}
          <p class="p" *ngIf="notificationList && notificationList.length == 0">{{noNotificationsMsg}}</p>
        </div>
        <div class="mt-2 mb-2">
          <button (click)="checkAll()" class="btn">
            <p class="btn-text">{{ 'orgnotificationsetting.selectall' | trans }}</p>
          </button>
          <button (click)="checkNone()" class="btn ml-2">
            <p class="btn-text">{{ 'orgnotificationsetting.unselectall' | trans }}</p>
          </button>
        </div>
        <p style="margin-bottom: 0px;">{{
          'orgnotificationsettingcustomeruser.thisisarethesettingsforthecurrentorganization' | trans
          }}</p>
        <div class="form-check">
          <input [checked]="overduecheck" (change)="setNotificationPreference($event,'projectturnsoverdue')"
            type="checkbox" class="form-check-input" [checked]="notificationpreferenceset.projectturnsoverdue">
          <label class="f-13 mb-0 font-weight-light" for="projectturnsoverdue_magicBtn">{{
            'orgnotificationsetting.projectturnsoverdue' | trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="memberfarbehindcheck" (change)="setNotificationPreference($event,'memberfarbehind')"
            id="memberfarbehind_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.memberfarbehind">
          <label class="f-13 mb-0 font-weight-light" for="memberfarbehind_magicBtn">{{
            'orgnotificationsetting.memberisfarbehindschedule' | trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="newprojectcheck" (change)="setNotificationPreference($event,'newproject')"
            id="newproject_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.newproject">
          <label class="f-13 mb-0 font-weight-light" for="newproject_magicBtn">{{
            'orgnotificationsetting.newprojectcreated' | trans }}</label>
        </div>
        <div *ngIf="showDeal" class="form-check">
          <input [checked]="newdealcheck" (change)="setNotificationPreference($event,'newdeal')" id="newdeal_magicBtn"
            type="checkbox" class="form-check-input" [checked]="notificationpreferenceset.newdeal">
          <label class="f-13 mb-0 font-weight-light" for="newdeal_magicBtn">{{ 'orgnotificationsetting.newdealcreated' |
            trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="projectdisabedcheck" (change)="setNotificationPreference($event,'projectdisabed')"
            id="projectdisabed_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.projectdisabed">
          <label class="f-13 mb-0 font-weight-light" for="projectdisabed_magicBtn">{{
            'orgnotificationsetting.projectdisabled' | trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="projectreenabledcheck" (change)="setNotificationPreference($event,'projectreenabled')"
            id="projectreenabled_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.projectreenabled">
          <label class="f-13 mb-0 font-weight-light" for="projectreenabled_magicBtn">{{
            'orgnotificationsetting.projectre-enabled' | trans }}</label>
        </div>
        <div class="form-check">
          <input [checked]="projectdeletedcheck" (change)="setNotificationPreference($event,'projectdeleted')"
            id="projectdeleted_magicBtn" type="checkbox" class="form-check-input"
            [checked]="notificationpreferenceset.projectdeleted">
          <label class="f-13 mb-0 font-weight-light" for="projectdeleted_magicBtn">{{
            'orgnotificationsetting.projectdeleted' | trans }}</label>
        </div>
      </ng-container>---->
      <div [@inbgOutAnimation] *ngIf="showcustomeruseroptions">
        <div class="alert alert-danger mr-0 ml-0" role="alert">
          {{ 'orgnotificationsettingcustomeruser.thisisarethesettingsforthecurrentorganization' | trans }}
        </div>
        <app-projectnotification [defaultSettings]="true" [projectId]="organizationId"></app-projectnotification>
      </div>

      <!---customer user notification settings end---->



    </div>
  </div>
</div>